<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.orders'), $t('text.list')]"> </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
          ></el-input>
        </el-form-item>
        <customer-search
          v-model="searchForm"
          fieldId="customerId"
          fieldName="customerName"
        />
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <el-form-item :prop="'categoryId'">
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('product.category')"
            clearable
            filterable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>

        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model.trim="searchForm.ownerId"
            :placeholder="$t('text.owner')"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="finishAt"
            :start-placeholder="$t('rules.startAt', [$t('dateTypes.finishAt')])"
            :end-placeholder="$t('rules.endAt', [$t('dateTypes.finishAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="customerReceiveAt"
            :start-placeholder="
              $t('rules.startAt', [$t('dateTypes.customerReceiveAt')])
            "
            :end-placeholder="
              $t('rules.endAt', [$t('dateTypes.customerReceiveAt')])
            "
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown @command="selectFlag">
              <el-button type="default" size="mini">
                {{ $t("action.flag") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(flag, index) in flags"
                  :key="index"
                  :command="flag"
                >
                  <flag :name="flag" />
                  {{ $t("flags." + flag) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              type="default"
              size="mini"
              class="mgl10"
              @click="print('printListDiv')"
            >
              {{ $t("action.print") }}
            </el-button>

            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}，
              <!-- {{ pager.productNoQty }} 款 {{ pager.qtyTotal }} 件, 成交额{{
                  pager.moneyTotal | currency
                }} --><span v-if="saleSearchCount != null">
                <span class="mgr5">
                  {{ saleSearchCount.productNoQty }} 款
                  {{ saleSearchCount.qtyTotal }} 件，成交额{{
                    saleSearchCount.moneyTotal | currency
                  }}
                </span>
                <span
                  v-if="
                    Permit.canActionsConfigDealType('available') &&
                    Permit.canActions('orderDeal-available')
                  "
                >
                  现货: {{ saleSearchCount.availableProductNoQty }} 款
                  {{ saleSearchCount.availableQtyTotal }} 件
                </span>
                <span
                  v-if="
                    Permit.canActionsConfigDealType('manufacture') &&
                    Permit.canActions('orderDeal-manufacture')
                  "
                >
                  / 生产: {{ saleSearchCount.manufactureProductNoQty }} 款
                  {{ saleSearchCount.manufactureQtyTotal }} 件
                </span>
                <span
                  v-if="
                    Permit.canActionsConfigDealType('purchase') &&
                    Permit.canActionsChargeEdition('orderDeal-purchase')
                  "
                >
                  / 外采: {{ saleSearchCount.purchaseProductNoQty }} 款
                  {{ saleSearchCount.purchaseQtyTotal }} 件
                </span>
              </span>
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="rowBgColor"
        size="mini"
        id="pendingsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column field="flags" :title="$t('text.flag')" width="50">
          <template v-slot="{ row }">
            <span v-if="row.flags != null && row.flags != ''">
              <flag
                :name="flag"
                :size="14"
                v-for="flag in JSON.parse(row.flags)"
                :key="flag"
              ></flag>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              {{ row.serialNo }}
            </a>
            <div class="font10">{{ row.innerSerialNo }}</div>
            <state-label
              :state="row.workflowState"
              :permit="Permit.canActions('orderDealView')"
            >
              <span v-if="Permit.canActions('orderDealView')">{{
                $t("orderStates." + row.workflowState)
              }}</span>
              <span v-else>{{
                $t("orderStatesNoPermit." + row.workflowState)
              }}</span>
            </state-label>
            <span v-if="row.isScore == true" class="font10 green">{{
              $t("order.isScore")
            }}</span>
            <div
              v-if="row.settlementId != null && row.settlementId != 0"
              class="green font10"
            >
              {{ $t("purchase.settlement") }}:{{ row.settleAt }}
            </div>
            <div
              v-if="row.orderBillId != null && row.orderBillSettleAt != null"
              class="green font10"
            >
              {{ $t("action.reportMonthSettlement") }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerType"
          :title="$t('menu.customers')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
            <div v-if="row.customerType != null" class="font10">
              {{ $t("customerTypes." + row.customerType) }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <div v-if="row.dealSuggest != null" class="red">
              <raw-html-limit-number :content="row.dealSuggest" :number="12" />
            </div>
            <div>
              <raw-html-limit-number
                :content="row.remark"
                :number="12"
                type="richText"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActions('globalSalePrice')"
          field="productPrice"
          :title="$t('order.salePrice')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.productPrice }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActions('globalSalePrice')"
          field="price"
          :title="$t('order.price')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.isScore == true"
              >{{ row.score
              }}<span class="font10">{{ $t("product.score") }}</span></span
            >
            <span v-else>
              <currency :code="row.currency"></currency>
              {{ row.price }}
              <small v-if="row.discountRate != null && row.discountRate != 0"
                >({{ row.discountRate }}%)</small
              >
              <div
                v-if="row.extraCharge != null && row.extraCharge != 0"
                class="font10"
              >
                {{ $t("order.extraChargeSimple") }}:
                <currency :code="row.currency"></currency>
                {{ row.extraCharge }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          width="60"
        >
          <template v-slot="{ row }">
            <span :class="Number(row.quantity) > 1 ? 'red font18' : ''">
              {{ row.quantity }}{{ row.unit }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="110"
          sortable
        ></vxe-table-column>

        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        >
          <template v-slot="{ row }">
            <span v-if="row.createAt.slice(11, 19) == '00:00:00'">
              {{ row.createAt.slice(0, 10) }}
            </span>
            <span v-else>
              {{ row.createAt }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerReceiveAt"
          :title="$t('dateTypes.customerReceiveAt')"
          width="110"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <!-- 打印列表 -->
    <div id="printListDiv" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr style="border: 1px solid black; text-align: center">
            <td style="border: 1px solid black; width: 120px">
              {{ $t("order.serialNo") }}
            </td>
            <td style="border: 1px solid black; width: 100px">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.category") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("menu.brands") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.color") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.size") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.remark") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.specJson") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.quantity") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.handOverAt") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.owner") }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("text.createAt") }}
            </td>
          </tr>

          <tr
            style="border: 1px solid black; text-align: center"
            v-for="(item, itemIndex) in selectRecords"
            :key="itemIndex"
          >
            <td style="border: 1px solid black">{{ item.serialNo }}</td>

            <td style="border: 1px solid black">{{ item.productNo }}</td>
            <td style="border: 1px solid black">
              {{ item.categoryName || "" }}
            </td>
            <td style="border: 1px solid black">
              {{ item.productBrand || "" }}
            </td>
            <td style="border: 1px solid black">{{ item.color || "" }}</td>
            <td style="border: 1px solid black">{{ item.size || "" }}</td>
            <td style="border: 1px solid black">
              <raw-html :content="item.remark"></raw-html>
            </td>
            <td style="border: 1px solid black">
              {{ Util.tranJSONArrToString(item.specJson) }}
            </td>
            <td style="border: 1px solid black">
              {{ item.quantity }}{{ item.unit }}
            </td>
            <td style="border: 1px solid black">{{ item.handOverAt }}</td>

            <td style="border: 1px solid black">{{ item.ownerName }}</td>
            <td style="border: 1px solid black">{{ item.createAt }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import { flagsWithClear, flagsWithNone } from "@/utils/enums.js";
import RawHtml from "@/components/RawHtml";
import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";
import CustomerSearch from "@/components/CustomerSearch";

import User from "@/api/user.js";
import Order from "@/api/order.js";
import Brand from "@/api/brand";
import Category from "@/api/category";
import Show from "@/views/oms/bargains/showOrder.vue";
import Customer from "@/api/customer";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Show,
    RawHtml,
    DateRange,
    Currency,
    CustomerSearch,
  },

  data() {
    return {
      Util: Util,
      flags: flagsWithClear,
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: Order.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: Order.passRange,
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: "已发货未收货",
                key: "unReceiveYes",
                condition: { unReceive: "yes" },
              },
            ],
          },
          {
            label: this.$t("action.reportMonthSettlement"),
            items: [
              {
                label: this.$t("boolean.true"),
                key: "orderBillYes",
                condition: { orderBill: "yes" },
              },
              {
                label: this.$t("boolean.false"),
                key: "orderBillNo",
                condition: { orderBill: "no" },
              },
            ],
          },
        ],
      ],
      searchForm: {
        serialNo: null,
        productNo: null,
        categoryName: null,
        color: null,
        size: null,
        ownerId: null,
        customerId: null,
        customerName: null,
        createAtStartAt: null,
        createAtEndAt: null,
        finishAtStartAt: null,
        finishAtEndAt: null,
        customerReceiveAtStartAt: null,
        customerReceiveAtEndAt: null,
        specJson: null,
      },
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "orders_productNo",
        handOverAt: "orders_handOverAt",
      },
      saleSearchCount: null,
      users: [],
      categories: [],
      //
      currentRowId: null,
      currentRowIdx: null,
      show: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    this.narrowsWorkflowStates();
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Brand.findByTenantId(),
        Category.findByTenantId(),
      ])
      .then(
        axios.spread(function (users, brands, categories) {
          if (users.status === 200) {
            self.users = users.data.filter((u) => u.authorize === true);
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
            self.narrowsBrands();
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    narrowsBrands() {
      if (this.brands.length != 0) {
        this.narrows.push([
          {
            label: this.$t("product.brand"),
            items: this.brands.map((brand) => {
              return {
                label: brand.name,
                key: brand.name,
                condition: { productBrand: brand.name },
              };
            }),
          },
        ]);
      }
    },
    narrowsWorkflowStates() {
      const self = this;
      if (self.Permit.canActions("orderDealView")) {
        var states = ["pending"];
        if (self.Permit.canActionsConfigDealType("available")) {
          states = states.concat(Order.states_available);
        }
        if (self.Permit.canActionsConfigDealType("purchase")) {
          states = states.concat(Order.states_purchase);
        }
        if (self.Permit.canActionsConfigDealType("manufacture")) {
          states = states.concat(Order.states_manufacture);
        }
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: states.concat(Order.states_after).map((s) => {
              return {
                key: s,
                label: self.$t("orderStates." + s),
                condition: { workflowStates: [s] },
              };
            }),
          },
        ]);
      } else {
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: Order.states_no_permint_replenish.map((s) => {
              return {
                key: s.key,
                label: self.$t("orderStates." + s.key),
                condition: { workflowStates: s.workflowStates },
              };
            }),
          },
        ]);
      }
      if (window.location.href.indexOf("unconfirms") != -1) {
        self.initFilter = "confirming";
      } else {
        self.initFilter = null;
      }
    },

    print(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneValidData"));
        return;
      }
      self.printFunction(type);
    },
    // 下载
    download(type) {
      const self = this;
      if (type == "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((c) => c.id),
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Order.saleExportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    //=====
    // 标旗帜
    selectFlag(flag) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const data = [];

      for (const c of self.selectRecords) {
        const obj = { uuid: c.uuid, flags: null };
        if (flag === "clear") {
          obj.flags = JSON.stringify([]);
        } else {
          const arr = c.flags != null ? JSON.parse(c.flags) : [];
          const newArr = arr.concat([flag]);
          obj.flags = JSON.stringify(newArr);
        }
        data.push(obj);
      }
      // console.log(flag, "===", data);
      Order.updateFlags(data).then(function (res) {
        if (res.status === 200) {
          for (const o of self.selectRecords) {
            o.flags = data.find((d) => d.uuid == o.uuid).flags;
          }
          self.$message({
            message: self.$t("prompt.signSuccess"),
            type: "success",
          });
          self.clearSelected();
        } else {
          self.sysError();
        }
      });
    },
    //
    showRecord(order) {
      this.currentRowId = order.id;
      this.show = true;
    },

    //======
    dataProvider(params) {
      return Order.saleSearch(params);
      //
    },
    recordsDecorate(records) {
      const self = this;
      this.records = records;
      Order.saleSearchCount(self.combineParams()).then(function (res) {
        if (res.status == 200) {
          self.saleSearchCount = res.data;
        } else {
          self.sysError();
        }
      });
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
